import React from 'react';
import { Form, Input, Checkbox, DatePicker } from 'antd';
import moment from 'moment';
import isNumeric from 'antd/es/_util/isNumeric';

const PhysicalForm = props => {
  const requiredRule = {
    required: true,
    message: 'Поле, обязательное для заполнения'
  };
  const { form } = props;
  const { getFieldDecorator, getFieldValue } = form;
  const birthDate = getFieldValue('birthDate');
  const hasNoPatronymic = getFieldValue('hasNoPatronymic');
  return (
    <div className="add-customer-form__physical">
      <div className="add-customer-form__main-block">
        <div className="add-customer-form__unit">
          <span className="add-customer-form__label">Фамилия:</span>
          <div className="add-customer-form__item">
            <Form.Item>
              {getFieldDecorator('lastname', {
                rules: [requiredRule]
              })(
                <Input
                  className="add-customer-form__input"
                  placeholder="Укажите фамилию"
                  style={{ width: '224px' }}
                />
              )}
            </Form.Item>
          </div>
        </div>
        <div className="add-customer-form__unit">
          <span className="add-customer-form__label">Имя:</span>
          <div className="add-customer-form__item">
            <Form.Item>
              {getFieldDecorator('name', {
                rules: [requiredRule]
              })(
                <Input
                  className="add-customer-form__input"
                  placeholder="Укажите имя"
                  style={{ width: '224px' }}
                />
              )}
            </Form.Item>
          </div>
        </div>
        <div className="add-customer-form__unit">
          <span className="add-customer-form__label">Отчество:</span>
          <div className="add-customer-form__item">
            <Form.Item>
              {/*здесь надо подумать как назначить валидацию. Нужно обсудить в Серёжей*/}
              {getFieldDecorator('patronymic')(
                <Input
                  className="add-customer-form__input"
                  placeholder="Укажите отчество"
                  disabled={hasNoPatronymic}
                  style={{ width: '224px' }}
                />
              )}
            </Form.Item>
            {getFieldDecorator('hasNoPatronymic', {
              valuePropName: 'hasNoPatronymic'
            })(
              <Checkbox className="add-customer-form__after">
                Нет отчества
              </Checkbox>
            )}
          </div>
        </div>
        <div className="add-customer-form__unit">
          <span className="add-customer-form__label">Дата рождения:</span>
          <div className="add-customer-form__item">
            <Form.Item>
              {getFieldDecorator('birthDate', {
                rules: [requiredRule]
              })(
                <DatePicker
                  placeholder="ДД.ММ.ГГГГ"
                  style={{ width: '224px' }}
                  defaultPickerValue={moment().subtract(18, 'years')}
                  format={'DD.MM.YYYY'}
                  disabledDate={d => {
                    return !moment()
                      .subtract(18, 'years')
                      .isAfter(d);
                  }}
                />
              )}
            </Form.Item>
            <span className="add-customer-form__label">
              {birthDate && moment(birthDate).fromNow(true)}
            </span>
          </div>
        </div>
        <div className="add-customer-form__unit">
          <span className="add-customer-form__label">Место рождения:</span>
          <div className="add-customer-form__item">
            <Form.Item>
              {getFieldDecorator('birthPlace')(
                <Input
                  className="add-customer-form__input"
                  placeholder="Укажите место рождения"
                  style={{ width: '368px' }}
                />
              )}
            </Form.Item>
          </div>
        </div>
        <div className="add-customer-form__unit double-margin">
          <span className="add-customer-form__label">Серия паспорта:</span>
          <div className="add-customer-form__item">
            <Form.Item>
              {getFieldDecorator('passportSeries', {
                rules: [
                  {
                    validator: function(rule, value, callback) {
                      if (!isNumeric(value) && value) {
                        callback("Недопустимый символ");
                      } else {
                        callback();
                      }
                    }
                  }
                ]
              })(
                <Input
                  className="add-customer-form__input"
                  placeholder="Укажите серию паспорта"
                  style={{ width: '224px' }}
                  maxLength={4}
                />
              )}
            </Form.Item>
          </div>
        </div>
        <div className="add-customer-form__unit">
          <span className="add-customer-form__label">Номер паспорта:</span>
          <div className="add-customer-form__item">
            <Form.Item>
              {getFieldDecorator('passportNumber', {
                rules: [
                  {
                    validator: function(rule, value, callback) {
                      if (!isNumeric(value) && value) {
                        callback("Недопустимый символ");
                      } else {
                        callback();
                      }
                    }
                  }
                ]
              })(
                <Input
                  className="add-customer-form__input"
                  placeholder="Укажите номер паспорта"
                  style={{ width: '224px' }}
                  maxLength={6}
                />
              )}
            </Form.Item>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhysicalForm;
